/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Add_New_TagInputs */

const en_dialog_add_new_tag = /** @type {(inputs: Dialog_Add_New_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new tag`)
};

const es_dialog_add_new_tag = /** @type {(inputs: Dialog_Add_New_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nueva etiqueta`)
};

/**
* | output |
* | --- |
* | "Add new tag" |
*
* @param {Dialog_Add_New_TagInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_add_new_tag = /** @type {((inputs?: Dialog_Add_New_TagInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Add_New_TagInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_add_new_tag(inputs)
	return en_dialog_add_new_tag(inputs)
});